import styled from 'styled-components';
import { theme } from '@/lib';

const Slider = styled.div`
  position: relative;
  margin: 12px 0;

  &.disabled input::-webkit-slider-thumb {
    cursor: not-allowed;
  }

  .progress {
    &-bar {
      position: absolute;
      top: 5px;
      left: 7px;
      height: 6px;
      width: calc(100% - 14px);
      background-color: transparent;
      overflow: visible;
    }
    &-fill {
      position: absolute;
      left: 0;
      height: 100%;
      border-radius: 6px;
      background: ${theme.clientColor.primaryLinear};
      &::before {
        position: absolute;
        left: -7px;
        content: '';
        width: 10px;
        border-radius: 6px 0 0 6px;
        background-color: #c669ff;
        height: 100%;
      }
    }
    &-val {
      display: none;
      box-sizing: border-box;
      position: absolute;
      z-index: 3;
      bottom: 14px;
      right: -12px;
      width: 24px;
      font-size: 12px;
      padding-top: 6px;
      height: 30px;
      background: url(${require('../images/icon-slider-tip.png')}) no-repeat
        center / contain;
      color: ${theme.clientColor.third};
      pointer-events: none;
      text-align: center;
    }
  }

  .form-item-label {
    margin-right: 8px;
  }

  .form-item-input {
    position: relative;
    &:hover {
      .progress-val {
        display: block;
      }
    }
  }
  input {
    height: 14px;
    flex: 1;
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    &::-webkit-slider-runnable-track {
      border-radius: 6px;
      background: #454d56;
      height: 6px;
    }
    &::-webkit-slider-thumb {
      position: relative;
      z-index: 2;
      -webkit-appearance: none;
      appearance: none;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #fff;
      margin-top: -4px;
      box-shadow: none;
      cursor: pointer;
    }
  }
`;

export default {
  Slider,
};
